import { create } from 'zustand';
import { SETTINGS_KEY } from '../config';
import { safeStorage } from '../lib/storage';

/** Per-device preferences. Geolocation in steps is OFF by default (privacy; drivers turn it on themselves). */
interface SettingsState {
  geo: boolean;
  setGeo: (v: boolean) => void;
}

function read(): { geo: boolean } {
  try {
    const v = JSON.parse(safeStorage.get(SETTINGS_KEY) ?? '{}') as { geo?: unknown };
    return { geo: v.geo === true };
  } catch {
    return { geo: false };
  }
}

export const useSettings = create<SettingsState>((set) => ({
  ...read(),
  setGeo(geo) {
    safeStorage.set(SETTINGS_KEY, JSON.stringify({ geo }));
    set({ geo });
  },
}));

/** Current position when the toggle is on and the phone allows it; otherwise null (never blocks a step). */
export function currentPosition(timeoutMs = 8000): Promise<{ lat: number; lng: number } | null> {
  const geo = globalThis.navigator?.geolocation;
  if (!geo) return Promise.resolve(null);
  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(null), timeoutMs + 500);
    geo.getCurrentPosition(
      (p) => {
        clearTimeout(timer);
        resolve({ lat: Math.round(p.coords.latitude * 1e6) / 1e6, lng: Math.round(p.coords.longitude * 1e6) / 1e6 });
      },
      () => {
        clearTimeout(timer);
        resolve(null);
      },
      { enableHighAccuracy: false, timeout: timeoutMs, maximumAge: 60_000 },
    );
  });
}
